import { List, ListProps } from '@portalterreno/react-ui-core/List';
import React from 'react';

import CopyLinkButton from './Buttons/CopyLinkButton';
import EmailButtonShare from './Buttons/EmailButtonShare';
import FacebookButtonShare from './Buttons/FacebookButtonShare';
import WhatsappButtonShare from './Buttons/WhatsappButtonShare';

export type ButtonListProps = ListProps;

const ButtonList: React.FC<ButtonListProps> = ({ ...rest }) => {
  return (
    <List {...rest}>
      <WhatsappButtonShare />
      <CopyLinkButton />
      <FacebookButtonShare />
      <EmailButtonShare />
    </List>
  );
};

export default ButtonList;
